import styled from "styled-components";

export const Form = styled.form`
  width: 50vw;
  background-color: ${(props) => props.theme.tokens.colors.surface};
  padding: 24px;
  margin-top: 20px;
  margin-bottom: 10px;

  border-radius: ${(props) => props.theme.tokens.radii.xl}px;
  box-shadow: ${(props) => props.theme.tokens.shadows.card};

  @media (max-width: 1024px) {
    width: 95vw;
    padding: 16px;
  }
`;

export const Section = styled.p`
  color: ${(props) => props.theme.tokens.colors.ink};
  font-size: 18px;
  font-family: ${(props) => props.theme.tokens.font.family};
  font-weight: 800;

  padding-bottom: 20px;
  padding-top: 10px;
`;

export const ImageFila = styled.img.attrs(() => ({
  src: "../../payment/fila.png",
}))`
  width: 32px;
  height: 32px;
  margin-right: 10px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.tokens.colors.bg};
  padding-bottom: 50px;
  min-height: 100vh;
`;

export const ImageCartDark = styled.img.attrs(() => ({
  src: "../../media/cart_dark.png",
}))`
  width: 24px;
  height: 24px;
  margin-right: 16px;
`;

export const LineContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: left;
`;
